import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ubs-view-list-container',
  templateUrl: './view-list-container.component.html',
  styleUrls: ['./view-list-container.component.scss']
})
export class ViewListContainerComponent implements OnInit {
  @Input() value:any;
  @Input() componentConfig:any;
  @Input() options:any;
  
  constructor() { }

  ngOnInit(): void {
    //console.log(this.options);
  }

}
